import React, { createContext, useContext, useState, useCallback } from 'react';

const FormContext = createContext();

export const useFormContext = () => useContext(FormContext);

export const FormProvider = ({ children }) => {
  const [validators, setValidators] = useState([]);

  // Возвращает функцию отписки — без неё валидаторы размонтированных форм
  // (например, PickupForm после переключения на доставку) продолжали бы
  // выполняться и портить receivingInfo.
  const registerValidator = useCallback((validator) => {
    setValidators((prev) => [...prev, validator]);
    return () => {
      setValidators((prev) => prev.filter((v) => v !== validator));
    };
  }, []);

  const validateForms = useCallback(async () => {
    const validationResults = await Promise.all(validators.map((validator) => validator()));
    const isValid = validationResults.every((result) => result.isValid);
    const errors = validationResults.reduce((acc, result) => ({ ...acc, ...result.errors }), {});
    // Данные собираем прямо из результата валидации, а не из React state —
    // так вызывающий код не зависит от того, успел ли setState отрисоваться.
    const data = validationResults.reduce((acc, result) => ({ ...acc, ...(result.data || {}) }), {});
    return { isValid, errors, data };
  }, [validators]);

  return (
    <FormContext.Provider value={{ registerValidator, validateForms }}>
      {children}
    </FormContext.Provider>
  );
};
